<template>
    <div class="wizard-form--field" v-if="showDropZone()">
        <div class="wizard-drop-zone ui-form-field ui-form-field__input ui-form-field__file ui-form-field__base"
                :class="enhancedRootClasses">
            <label :for="id" class="ui-form-field--title-label">
                <slot name="label"/>
            </label>
            <div class="ui-form-field--input-container wizard-drop-zone--input-container">
                <input :name="name"
                        class="ui-form-field--input wizard-drop-zone--input"
                        type="file"
                        v-bind="$attrs"
                        :id="id"
                        ref="input"
                        @change="onChange"
                        @focus="onFocus"
                        @blur="onBlur"
                        v-on="$listeners">
                <div class="wizard-drop-zone--empty-label ui-form-field--empty-label">
                    <slot name="empty_label"/>
                </div>
                <button class="ui-form-field--empty-btn" @click="onDelete">
                    <ui-icon size="medium" symbol="close"/>
                </button>
            </div>
            <slot name="messages"/>
        </div>
    </div>
</template>

<script>
    import UiIcon from '@dreipol/vue-ui/src/components/icon/icon.vue';
    import bemMixin from '@dreipol/vue-ui/src/mixins/bem';
    import focusBehaviourMixin from '@dreipol/vue-ui/src/mixins/form/focus-behaviour';
    import hasErrorsPropsMixin from '@dreipol/vue-ui/src/mixins/form/has-errors-props';
    import { mapState } from 'vuex';

    export default {
        components: {
            UiIcon,
        },
        mixins: [
            bemMixin('ui-form-field'),
            focusBehaviourMixin,
            hasErrorsPropsMixin,
        ],
        props: {
            name: {
                type: String,
                required: true,
            },
            hideOptional: {
                type: Boolean,
                default: false,
            },
            isOptional: {
                type: Boolean,
                default: false,
            },
            diplomaIndex: {
                type: Number,
                required: false,
                default: 0,
            },
        },
        data() {
            return {
                hasValue: false,
            };
        },
        computed: {
            ...mapState('wizard', ['numberOfOptionalDocuments']),
            id() {
                return `id_${ this.name }`;
            },
            enhancedRootClasses() {
                return [
                    ...this.bemFacets,
                    this.hideOptional ? 'hide-optional' : '',
                    this.bemIf(this.hasFloatingLabel, 'floating-label'),
                    this.bemIf(this.hasErrors, 'has-error'),
                    this.bemIf(this.$attrs.required, 'is-required', 'is-optional'),
                    this.bemIf(this.$attrs.disabled, 'is-disabled'),
                    this.bemIf(this.hasFocus, 'has-focus'),
                    this.bemAdd(this.hasValue ? 'is-filled' : 'is-empty'),
                ];
            },
        },
        methods: {
            onChange(event) {
                this.hasValue = !!event.target.files.length;
            },
            onDelete(event) {
                event.preventDefault();
                this.$refs.input.files = new DataTransfer().files;
                this.hasValue = false;
            },
            showDropZone() {
                return !this.isOptional || this.diplomaIndex < this.numberOfOptionalDocuments;
            },
        },
    };
</script>
